<section class="h-100 bg-dark">
    <div class="container py-5 h-100">
        <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col">
                <div class="card card-registration my-4">
                    <div class="row g-0">
                        <div class="col-xl-6 d-none d-xl-block">
                            <img src="assets/images/reg.jpg" alt="Sample photo" class="img-fluid"
                                style="border-top-left-radius: 0.25rem;-bottom-left-radius: 0.25rem;" />
                        </div>
                        <div class="col-xl-6">

                            <div class="card-body p-md-5 text-black">
                                <h3 class="mb-5 text-uppercase">Registration Form</h3>

                                <form class="form" [formGroup]="registerForm">

                                    <label class="fw-bold">Basic Details</label>

                                    <div class="col-lg-12 d-flex justify-content-start">
                                        <div class="form-group mt-2">
                                            <label class="fw-bold" (click)="logo.click()" type="submit">Choose
                                                File</label>
                                            <div class="custom-file input-group">
                                                <input type="file" class="custom-file-input form-control " #logo
                                                    formControlName="imageUrl" (change)="onChangeImage(logo.files)"
                                                    id="customFile">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="error-msg-area">
                                            <div *ngIf="registerForm.controls['imageUrl'].errors && (!registerForm.controls['imageUrl'].pristine||isregisterFormSubmitted)"
                                                class="error-msg">
                                                <div [hidden]="!registerForm.controls['imageUrl'].errors.required" class="text-danger">Please
                                                    Select File</div>
                                                
                                            </div>
                                        </div> -->
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-12 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold">Name of Institution<span
                                                        class="required">*</span></label>
                                                <input class="form-control" type="text" formControlName="name"
                                                    name="moduleName" placeholder="Enter Name of Institution" />
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['name'].errors && (!registerForm.controls['name'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['name'].errors.required"
                                                        class="text-danger">Please
                                                        Enter Name of Institution</div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-12 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold ">Level of Membership<span
                                                        class="required">*</span></label>
                                                <ng-select [items]="arr" class="js-example-basic-multiple"
                                                    placeholder="Select"
                                                    (ngModelChange)="levelofmembershipChanged($event)" [multiple]="true"
                                                    formControlName="levelOfMembership"></ng-select>
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['levelOfMembership'].errors && (!registerForm.controls['levelOfMembership'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['levelOfMembership'].errors.required"
                                                        class="text-danger">Please
                                                        Select Level of Membership
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-12 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold ">Teritary Language</label>
                                                <ng-select [items]="lang" class="js-example-basic-multiple"
                                                    placeholder="Select" [multiple]="true" [maxSelectedItems]="2"
                                                    formControlName="tertiaryLanguage"></ng-select>
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['tertiaryLanguage'].errors && (!registerForm.controls['tertiaryLanguage'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['tertiaryLanguage'].errors.required"
                                                        class="text-danger">Please
                                                        Select Tertiary Language
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-12 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold">High School Language</label>
                                                <ng-select [items]="lang" class="js-example-basic-multiple"
                                                    placeholder="Select" [multiple]="true" [maxSelectedItems]="2"
                                                    formControlName="highSchoolLanguage"></ng-select>
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['highSchoolLanguage'].errors && (!registerForm.controls['highSchoolLanguage'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['highSchoolLanguage'].errors.required"
                                                        class="text-danger">Please
                                                        Select High School Language
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-12 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold ">Primary Language</label>
                                                <ng-select [items]="lang" class="js-example-basic-multiple"
                                                    placeholder="Select" [multiple]="true" [maxSelectedItems]="2"
                                                    formControlName="primaryLanguage"></ng-select>
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['primaryLanguage'].errors && (!registerForm.controls['primaryLanguage'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['primaryLanguage'].errors.required"
                                                        class="text-danger">Please
                                                        Select Primary Language
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="fw-bold mt-2">Details for Communication</label>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold">Email<span class="required">*</span></label>
                                                <input class="form-control" type="email"
                                                    placeholder="Enter Email Address " formControlName="email"
                                                    name="email"
                                                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" />
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['email'].errors && (!registerForm.controls['email'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['email'].errors.required"
                                                        class="text-danger">Please
                                                        Enter Email
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['email'].errors && registerForm.controls['email'].touched"
                                                    class="error-msg">
                                                    <div *ngIf="registerForm.controls['email'].errors.pattern">Please
                                                        Enter Valid Email
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group field">
                                                <label class="fw-bold">Address<span class="required">*</span></label>
                                                <input type="text" class="form-control" placeholder="Enter Address"
                                                    formControlName="address" />
                                                <div class="error-msg-area">
                                                    <div *ngIf="registerForm.controls['address'].errors && (!registerForm.controls['address'].pristine||isregisterFormSubmitted)"
                                                        class="error-msg">
                                                        <div [hidden]="!registerForm.controls['address'].errors.required"
                                                            class="text-danger">Please
                                                            Select Address
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold ">City<span
                                                        class="required">*</span></label><br />
                                                <input type="text" class="form-control" placeholder="Enter City/Town"
                                                    formControlName="city_Town" />
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['city_Town'].errors && (!registerForm.controls['city_Town'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['city_Town'].errors.required"
                                                        class="text-danger">Please
                                                        Enter City/Town
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold">State<span class="required">*</span></label>
                                                <input type="text" class="form-control" placeholder="Enter State"
                                                    formControlName="state" />
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['state'].errors && (!registerForm.controls['state'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['state'].errors.required"
                                                        class="text-danger">Please
                                                        Enter State
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold ">Country<span class="required">*</span></label>
                                                <select class="form-control rounded-right" formControlName="country">
                                                    <option value="" disable>--Select--</option>
                                                    <option>India</option>
                                                </select>
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['country'].errors && (!registerForm.controls['country'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['country'].errors.required"
                                                        class="text-danger">Please
                                                        Select Country
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold">Pin Code<span class="required">*</span></label>
                                                <input type="text" class="form-control" placeholder="Enter PIN Code"
                                                    formControlName="pincode" />
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['pincode'].errors && (!registerForm.controls['pincode'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['pincode'].errors.required"
                                                        class="text-danger">Please
                                                        Enter Pincode
                                                    </div>
                                                    <div [hidden]="!registerForm.controls['pincode'].errors?.pattern"
                                                        class="text-danger">Please
                                                        Enter A Valid Pincode
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-6 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold ">Mobile No<span class="required">*</span></label>
                                                <input class="form-control" type="tel" placeholder="Enter Mobile Number"
                                                    formControlName="mobileNumber" name="email" pattern="[0-9]{10}" />
                                            </div>
                                            <div class="error-msg-area">
                                                <div *ngIf="registerForm.controls['mobileNumber'].errors && (!registerForm.controls['mobileNumber'].pristine||isregisterFormSubmitted)"
                                                    class="error-msg">
                                                    <div [hidden]="!registerForm.controls['mobileNumber'].errors.required"
                                                        class="text-danger">Please
                                                        Enter Mobile No
                                                    </div>
                                                    <div [hidden]="!registerForm.controls['mobileNumber'].errors?.pattern"
                                                        class="text-danger">Please
                                                        Enter A Valid Mobile No
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="fw-bold mt-2">Payment Details</label>
                                    <div class="row mt-2">
                                        <div class="col-md-6 col-lg-12 col-sm-6">
                                            <div class="form-group">
                                                <label class="fw-bold">Amount<span class="required">*</span></label>
                                                <input type="text" class="form-control disable"
                                                    formControlName="amount" />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div class="d-flex justify-content-end pt-3">
                                    <button type="submit" [disabled]="disablePay" (click)="payNow()"
                                        class="btn btn-primary btn-lg ms-2">
                                        Pay
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="h-100 h-custom d-none" style="background-color: #8fc4b7">
    <div class="container py-5 h-100">
        <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col-lg-8 col-xl-6">
                <div class="card rounded-3">
                    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img3.webp"
                        class="w-100" style="
              border-top-left-radius: 0.3rem;
              border-top-right-radius: 0.3rem;
            " alt="Sample photo" />
                    <div class="card-body p-4 p-md-5">
                        <h3 class="mb-4 pb-2 pb-md-0 mb-md-5 px-md-2">Registration Form</h3>

                        <form class="form">
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold">Name<span class="required">*</span></label>
                                        <input class="form-control mt-3" type="text" formControlName="moduleName"
                                            name="moduleName" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">Level of Membership<span
                                                class="required">*</span></label>
                                        <select class="form-control rounded-right"
                                            formControlName="levelOfMemebershipId">
                                            <option value="" disable>--Select--</option>
                                            <option>Primary</option>
                                            <option>Primary</option>
                                            <option>Primary</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold">Mobile No<span class="required">*</span></label>
                                        <input class="form-control mt-3" type="text" formControlName="mobileNumber"
                                            name="email" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">Landline No<span class="required">*</span></label>
                                        <input class="form-control" type="text" formControlName="landlineNumber"
                                            name="number" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold">Email<span class="required">*</span></label>
                                        <input class="form-control mt-3" type="email" formControlName="email"
                                            name="email" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">Amount<span class="required">*</span></label>
                                        <input class="form-control" type="number" formControlName="number"
                                            name="number" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold">Address<span class="required">*</span></label>
                                        <input class="form-control mt-3" type="text" formControlName="address"
                                            name="email" />
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">City<span class="required">*</span></label>
                                        <select class="form-control rounded-right" formControlName="city_Town">
                                            <option value="" disable>--Select--</option>
                                            <option></option>
                                            <option></option>
                                            <option></option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold mt-3">State<span class="required">*</span></label>
                                        <select class="form-control rounded-right" formControlName="city_Town">
                                            <option value="" disable>--Select--</option>
                                            <option></option>
                                            <option></option>
                                            <option></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">Pin Code<span class="required">*</span></label>
                                        <input class="form-control" type="number" formControlName="pincode"
                                            name="number" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold mt-3">Country<span class="required">*</span></label>
                                        <select class="form-control rounded-right" formControlName="country">
                                            <option value="" disable>--Select--</option>
                                            <option></option>
                                            <option></option>
                                            <option></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">Installment<span class="required">*</span></label>
                                        <input class="form-control" type="text" formControlName="installment"
                                            name="number" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <label class="fw-bold ">Installment Amount<span
                                                class="required">*</span></label>
                                        <input class="form-control" type="text" formControlName="installmentAmount"
                                            name="number" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>